var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "viewport",
          rawName: "v-viewport",
          value: _vm.onViewportIntersection,
          expression: "onViewportIntersection",
        },
      ],
      staticClass: "rb-algolia-popular-searches",
    },
    [
      _vm.trendingFacets.length > 0
        ? _c(
            "div",
            { staticClass: "rb-algolia-popular-searches__items" },
            [
              _c(
                "rb-anchors-bar",
                { attrs: { "caret-is-light": true, "can-be-sticky": false } },
                _vm._l(
                  _vm.trendingFacets.slice(0, _vm.maxNumber),
                  function (facet, index) {
                    return _c("rb-popular-search", {
                      key: index,
                      attrs: {
                        category: facet.category,
                        "search-term": facet.label,
                      },
                    })
                  }
                ),
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "skeleton block-skeleton" },
            _vm._l(6, function (index) {
              return _c("div", {
                key: index,
                staticClass: "dummy-text dummy-text__element",
              })
            }),
            0
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }